import { CategoryProcessor } from "./CategoryProcessor";
export class CategoryFiveProcessor extends CategoryProcessor {
    getCategory() {
        return 'five';
    }
}
